import React from 'react';
import { Stack } from '@fluentui/react';
import 'katex/dist/katex.min.css';
import styles from './Message.module.scss';
import MessageComponent from './MessageComponent';
import IMessage from '../../../models/IMessage';
import constants from '../../../constants/Constansts';

const Message: React.FC<IMessage> = (MessageProps: IMessage) => {
  const { isUser } = MessageProps;
  return (
    <Stack
      horizontalAlign={isUser ? 'end' : 'start'}
      className={styles.rootMsgContainer + ' ' + constants.MessageContainerClass}
      styles={{
        root: {
          width: '100%',
          marginBottom: '10px',
          paddingLeft: isUser ? '50px' : '0',
          paddingRight: isUser ? '0' : '50px',
          borderRadius: '1.5rem'
        },
      }}

    >
      <MessageComponent {...MessageProps} />
    </Stack>
  );
};

export default Message;

